function addB2BCartTotalAttribute() {
  const cartTotalElement = document.querySelector('.cart__form .cart__total__price[data-cart-total]');
  if (cartTotalElement && !cartTotalElement.hasAttribute('bss-b2b-cart-total-price')) {
      cartTotalElement.setAttribute('bss-b2b-cart-total-price', ''); 
  } 
}

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            for (let item of MutationList) {
                if (item.target.classList.contains('cart__total__price')) {
                    addB2BCartTotalAttribute();
                    BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
                }
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)
}